module.exports = __webpack_public_path__ + "img/client13.03966892.svg";